import { Stats } from 'lib/types';
import { STAT_TEXT, ORDERED_STATS_TOTAL } from 'lib/constants';
import { abbreviateNum } from 'lib/helpers';
import { Skeleton } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';

interface Props {
  stats: Stats;
  isLoading?: boolean;
  error?: Error;
}

export const PostStats = ({ stats, isLoading = false, error }: Props) => {
  if (isLoading) {
    return <Skeleton className="min-w-[320px] w-full" variant="text" />;
  }
  if (stats.totalPosts === 0) {
    return null;
  }

  // If there are no posts, don't render anything.
  // This can happen when searching for images from text
  // because those stats are basically meaningless.
  if (!stats?.totalPosts) {
    return null;
  }
  if (error) {
    return (
      <p className="text-sm">
        <ErrorIcon />
        {' '}
        Error fetching stats. Try again later.
      </p>
    );
  }

  return (
    <ul className="flex flex-wrap w-full">
      {ORDERED_STATS_TOTAL.map((key) => {
        const text = STAT_TEXT[key];
        const stat = stats[key as keyof Stats];
        if (stat <= 0) {
          return null;
        }

        return (
          <li className="pr-4 last:pr-0" key={key}>
            <span>
              {abbreviateNum(stat, 1)}
              &nbsp;
            </span>
            <span className="font-semibold">
              {text}
            </span>
          </li>
        );
      })}
    </ul>
  );
};

interface DiffProps {
  stats: Stats;
}

export const DiffPostStats = ({ stats }: DiffProps) => {
  if (stats.totalPosts === 0) {
    return null;
  }
  return (
    <div className="flex flex-wrap justify-center">
      {ORDERED_STATS_TOTAL.map((key) => {
        const text = STAT_TEXT[key];
        const stat = stats[key as keyof Stats];
        if ((stat <= 0) || stat === undefined) {
          return null;
        }

        return (
          <div className="pr-4 last:pr-0" key={key}>
            <span className="font-bold">
              +
              {abbreviateNum(stat, 1)}
              &nbsp;
            </span>
            <span>
              {text}
            </span>
          </div>
        );
      })}
    </div>
  );
};
